// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { OptionVolatilityLabChart } from '@front/chart/OptionVolatilityLabChart';
import { BaseChartRactive } from './BaseChartRactive';
export class OptionVolatilityLabChartRactive extends BaseChartRactive {
    getType() {
        return 'VolatilityLab';
    }
    createChart() {
        return new OptionVolatilityLabChart(this.context, super.get('terceraChartPanelContext'));
    }
}
